export default __webpack_public_path__ + "static/media/003-Black Panther.20d8809f.svg";